import React, { useEffect } from "react";
import "./toast.css";

type ToastProps = {
  type: "success" | "error";
  message: string;
  onClose: () => void;
};

const Toast: React.FC<ToastProps> = ({ type, message, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 15000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`toast toast-${type}`}>
      <span className="toast-message">{message}</span>
      <button
        type="button"
        className="toast-close"
        onClick={onClose}
        aria-label="Dismiss"
      >
        &times;
      </button>
    </div>
  );
};

export default Toast;